/**
 * ContextualBreadcrumb
 * Breadcrumb navigation component showing the current path
 */

import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  icon?: React.ReactNode;
}

export interface ContextualBreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function ContextualBreadcrumb({ items, className = '' }: ContextualBreadcrumbProps) {
  return (
    <nav className={`flex min-w-0 flex-wrap items-center gap-2 text-sm ${className}`} aria-label="Breadcrumb">
      {/* Home */}
      <Link
        to="/"
        className="text-muted-foreground hover:text-foreground transition-colors"
        title="Início"
      >
        <Home className="h-4 w-4" />
      </Link>

      {items.length > 0 && <ChevronRight className="size-4 shrink-0 text-muted-foreground/60" aria-hidden="true" />}

      {/* Breadcrumb Items */}
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={index} className="flex min-w-0 items-center gap-2">
            {item.href && !isLast ? (
              <Link
                to={item.href}
                className="flex min-w-0 items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
              >
                {item.icon}
                <span className="truncate">{item.label}</span>
              </Link>
            ) : (
              <span className={`flex min-w-0 items-center gap-1 ${isLast ? 'text-foreground font-medium' : 'text-muted-foreground'}`}>
                {item.icon}
                <span className="truncate">{item.label}</span>
              </span>
            )}

            {!isLast && <ChevronRight className="size-4 shrink-0 text-muted-foreground/60" aria-hidden="true" />}
          </div>
        );
      })}
    </nav>
  );
}
